<template>
    <md-dialog :title="title" :closable="false" v-model="noticeopen" :btns="niticebtns" class="notice">
        <div v-html="content"></div>
    </md-dialog>
</template>
  
<script>
export default {
    name: 'notice',
    data() {
        return {
            niticebtns: [
                {
                    text: 'Confirm',
                },
            ],
            noticeopen: true
        }
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Notice"
        }
    },
    watch: {
        open(newval) {
            if (newval) {
                this.noticeopen = newval;
            }
        }
    },
    created() {
        if (this.noticeopen) {
            var lastshow = localStorage.getItem("lastshow");
            if (lastshow) {
                var nowtime = new Date().getTime();
                if (nowtime - lastshow < 1000 * 60 * 5) {
                    this.noticeopen = false;
                    return;
                }
            }
            localStorage.setItem("lastshow", new Date().getTime());
        }
    }
}
</script>
<style scoped>
.notice-title {
    font-size: 0.2rem;
}

.notice>>>.md-fade {
    height: 11rem;
}
</style>



// WEBPACK FOOTER //
// src/components/notice.vue